import PaintCommercialConfigWorkspace from '../../placeholders/PaintCommercialConfigWorkspace';

export default PaintCommercialConfigWorkspace;
